import { DjinniAPI } from '@/api';

export const DjinniStore = {
  namespaced: true,
  state: {
    data: [],
    selected: {},
    show_modal: false,
    mode: '', // create || edit
  },
  mutations: {

    openModal(state) {
      state.show_modal = true;
    },

    toggleModal(state, status) {
      state.show_modal = status;
    },

    closeModal(state) {
      state.show_modal = false;
    },

    setData(state, data) {
      state.data = data;
    },

    setForEdit(state, data) {
      state.selected = _.cloneDeep(data);
      state.mode = 'edit';
    },

    setForCreate(state) {
      state.selected = _.cloneDeep(ForumDTO);
      state.mode = 'create';
    },
  },
  actions: {

    updateData({ state, commit }) {
      return DjinniAPI.selectAll().then(res => {
        commit('setData', res.data);
      })
    },
  },
  getters: {

    data(state) {
      return state.data;
    },

    mode(state) {
      return state.mode;
    },

    selected(state) {
      return state.selected;
    },

    showModal(state) {
      return state.show_modal;
    },
  }
};
